import { paymentApi } from 'services/http';
import { alertError } from 'services/alerts';
import { parseFilterParams } from '../services';

//──── Constants ─────────────────────────────────────────────────────────────────────────
// Filter
export const UPDATE_REPORT_FILTER = 'UPDATE_REPORT_FILTER';
export const CLEAR_REPORT_FILTER = 'CLEAR_REPORT_FILTER';
// List
export const CLEAR_REPORT_LIST = 'CLEAR_REPORT_LIST';
export const SET_REPORT_LIST = 'SET_REPORT_LIST';

//──── Actions ───────────────────────────────────────────────────────────────────────────

// filters
export const updateReportFilter = filterObj => dispatch => {
  const params = parseFilterParams(filterObj);

  dispatch({
    type: UPDATE_REPORT_FILTER,
    payload: filterObj
  });

  paymentApi
    .get('invoices/statistics', { params })
    .then(({ data }) => {
      dispatch(updateReportList(data));
    })
    .catch(({ response }) => {
      if (response && response.status !== 400 && response.status !== 401) {
        dispatch(updateReportList(null));
        alertError();
      }
    });
};

const clearReportFilter = () => ({
  type: CLEAR_REPORT_FILTER
});

// Reports
export const clearReportList = () => ({
  type: CLEAR_REPORT_LIST
});

const updateReportList = data => ({
  type: SET_REPORT_LIST,
  payload: data
});

export const clearReportStore = () => dispatch => {
  dispatch(clearReportFilter());
  dispatch(clearReportList());
};

//──── Store ─────────────────────────────────────────────────────────────────────────────
const initialState = {
  reportFilter: null,
  reportPaidList: null,
  reportUnpaidList: null,
};

export default (state = { ...initialState }, action) => {
  switch (action.type) {
    // Filter
    case UPDATE_REPORT_FILTER:
      return { ...state, reportFilter: action.payload };
    case CLEAR_REPORT_FILTER:
      return { ...state, reportFilter: null };
    // List
    case CLEAR_REPORT_LIST:
      return { ...state, reportPaidList: null, reportUnpaidList: null };
    case SET_REPORT_LIST: {
      const { paid, unpaid } = action.payload;
      return {
        ...state,
        reportPaidList: paid || null,
        reportUnpaidList: unpaid || null
      };
    }

    default:
      return state;
  }
};
